import { useQuery } from "@tanstack/react-query";
import { useModalStore } from "../../store/useModalStore";
import { useAuthInfo } from "../../lib/apis/hooks/auth.hook";
import Button from "../../components/ui/button";
import { formatDate } from "../../utils/date.utils";
import { MODAL_KEY } from "../../lib/constants/modal.constants";
import type { Role } from "../../types/auth.types";

export default function UserInfo() {
  const { openModal } = useModalStore();
  const { data, isSuccess } = useQuery({ ...useAuthInfo() });
  const { result } = data || {};

  return (
    <div className="p-6">
      <div className="p-[16px]">
        <h2 className="text-[24px] ">마이페이지</h2>
        <p className="text-[14px]  text-[rgba(0,0,0,0.6)]">
          내 정보를 관리하세요.
        </p>
      </div>
      <table className="w-full mt-[12px]">
        <tbody>
          <tr className="content-table-tr">
            <td className="content-table-th">아이디</td>
            <td className="content-table-td">{result?.email || "-"}</td>
            <td className="content-table-th">비밀번호 변경</td>
            <td className="content-table-td">
              <Button
                size="md"
                variant={"outline"}
                label="비밀번호 변경"
                onClick={() => openModal(MODAL_KEY.PasswordReset, {})}
              />
            </td>
          </tr>
          <tr className="content-table-tr">
            <td className="content-table-th">가입일</td>
            <td className="content-table-td">
              {formatDate(result?.createdAt || "") || "-"}
            </td>
            <td className="content-table-th">권한</td>
            <td className="content-table-td">{result?.role as Role}</td>
          </tr>
          <tr className="content-table-tr">
            <td className="content-table-th">이름(닉네임)</td>
            <td className="content-table-td">{result?.username}</td>
            <td className="content-table-th">연락처</td>
            <td className="content-table-td">{result?.phone || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* 담당 지점 정보 */}
      {isSuccess &&
        (result?.stores || []).map(
          (
            {
              storeName,
              storeAddress,
              storeLink,
            }: {
              id: number;
              storeName: string;
              storeAddress: string;
              storeLink: string;
            },
            index: number
          ) => {
            return (
              <div
                key={index}
                className="border border-[rgba(255,255,255, 0.12)] p-[24px] w-full mt-[24px] rounded-[8px]"
              >
                <h2 className="p-[16px] pt-0 text-[22px] ">
                  {`${result?.role == "PARTNER" ? "담당" : "보유"} 지점 정보`}
                </h2>
                <table className="w-full">
                  <tbody>
                    <tr className="content-table-tr">
                      <td className="content-table-th">지점명</td>
                      <td className="content-table-td">{storeName || "-"}</td>
                      <td className="content-table-th">지점 주소</td>
                      <td className="content-table-td">
                        {storeAddress || "-"}
                      </td>
                    </tr>
                    <tr className="content-table-tr">
                      <td className="content-table-th">연결 링크</td>
                      <td className="content-table-td" colSpan={2}>
                        {storeLink || "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          }
        )}
    </div>
  );
}
